import classNames from 'classnames';
import React from 'react';
import './aboutSection.module.scss';

type Props = {
  title: string;
  description: string;
  image: string;
  color: 'blue' | 'green' | 'pink';
};

export const AboutSection = ({ title, description, image, color }: Props) => {
  return (
    <div styleName="about-section" data-testid="about-section">
      <div styleName={classNames('about-section-inner', color)}>
        <div styleName="about-section-content">
          <div styleName="text-content">
            <div styleName="title">{title}</div>
            <div styleName="description">{description}</div>
          </div>
          <img styleName="about-section-image" src={image} alt="about-section-image" />
        </div>
      </div>
    </div>
  );
};
